import { http, HttpResponse } from "msw";

export const TEST_CLI_TOKEN = "f3b3e3e3-3e3e-3e3e-3e3e-3e3e3e3e3e3e";

export const cliTokenHandlersStatic = [
  http.post("*/api/agent/deployments/:deploymentId/tokens/requests", () =>
    HttpResponse.json({}, { status: 200 })
  ),

  http.post("*/api/agent/tokens/requests", () =>
    HttpResponse.json(
      {
        token: TEST_CLI_TOKEN,
      },
      { status: 200 }
    )
  ),
];
